import React, { useState } from "react";
import styled from "styled-components";
import { useAuth } from "@/lib/Authentication/hooks/useAuth";
import {
  filterMePageItems,
  mePageItemsEnum,
} from "../../elements/CustomerProfile/consts";
import { useStore } from "@/lib/storeData/StoreContext";
import { Link } from "@/i18n/i18n-navigation";
import CentralizedModal from "@/components/Centralizedlogin/CentralizedModal";
import { AuthMode } from "@/generated/graphql";
import { FormattedMessage } from "@/i18n/i18n-client";
import { CustomerIcon } from "@/assets/Icons/CustomerIcon";

const AccountButton = () => {
  const { isLoggedIn, logout } = useAuth();
  const { areReviewsActivated, authMode } = useStore();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleLoginClick = () => {
    if (authMode === AuthMode.Modern) {
      setIsModalOpen(true);
    }
  };

  return (
    <>
      {isLoggedIn ? (
        <StyledContainer>
          {filterMePageItems(areReviewsActivated).map((item) =>
            item.id !== mePageItemsEnum.LogOut ? (
              <Link key={item.id} href={`/me/${item.slug}/`}>
                <StyledButton>
                  {item.icon}
                  {item.title}
                </StyledButton>
              </Link>
            ) : (
              <StyledButton key={item.id} onClick={logout}>
                {item.icon}
                {item.title}
              </StyledButton>
            )
          )}
        </StyledContainer>
      ) : authMode === AuthMode.Modern ? (
        <>
          <StyledContainer>
            <StyledButton onClick={handleLoginClick}>
              <CustomerIcon width="20px" height="20px" />
              <FormattedMessage defaultMessage="Login" id="AyGauy" />
            </StyledButton>
          </StyledContainer>
          <CentralizedModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          />
        </>
      ) : (
        <StyledContainer>
          <Link href={"/login"}>
            <StyledButton>
              <CustomerIcon width="20px" height="20px" />
              <FormattedMessage defaultMessage="Login" id="AyGauy" />
            </StyledButton>
          </Link>
        </StyledContainer>
      )}
    </>
  );
};

export default AccountButton;

const StyledContainer = styled.div`
  width: 100%;
`;

const StyledButton = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #c4cdd5;
  padding: 23px 16px;
  font-weight: 600;
  font-size: 16px;
  svg {
    margin-inline-end: 5px;
  }
`;
